import {applyMiddleware, combineReducers, createStore} from "redux";
import {itemsReducer} from "./items.reducer";
import ReduxThunk from "redux-thunk";
import logger from "redux-logger";
import { reducer as formReducer } from 'redux-form'
import {authenticateReducer} from './authenticate.reducer';
import {userReducer} from './user.reducer';
import {snackbarReducer} from './snackbar.reducer';
import {newsReducer} from './news.reducer';
import {GuidesReducer} from "./guides.reducer";
import {SkinsReducer} from "./skins.reducer";

export const store = createStore(
    combineReducers({
        Items: itemsReducer,
        form: formReducer,
        Authenticate: authenticateReducer,
        User: userReducer,
        Snackbar: snackbarReducer,
        News: newsReducer,
        Guides: GuidesReducer.reducer,
        Skins: SkinsReducer.reducer
    }),
        process.env.NODE_ENV === 'development' ?
            applyMiddleware(ReduxThunk, logger) :
            applyMiddleware(ReduxThunk)

);


// WEBPACK FOOTER //
// ./src/reducers/_store.js